import { Button, Stack } from '@mui/material';
import { AuthenticationResult } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';

import Logger from 'browser-logging/src/browser/Logger';

import { DevFeatures } from 'common/src/types/enums/ProductFeatures.enum';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import useAuth from 'portal/src/auth/useAuth';

const API_URL = import.meta.env.VITE_API_URL;

const MicrosoftLoginButton = ({
  onError,
  onSuccess,
}: {
  onError: () => void;
  onSuccess: (result: AuthenticationResult) => void;
}) => {
  const { instance } = useMsal();
  const { featureChecker } = useAuth();
  const workosLoginEnabled = featureChecker.devFeatureEnabled(
    DevFeatures.WorkOsLogin,
  );

  return (
    <Button
      variant="outlined"
      sx={{
        width: '24rem',
        height: '2.375rem',
        textTransform: 'none',
        borderColor: 'rgba(0, 0, 0, 0.23)',
      }}
      onClick={async () => {
        if (workosLoginEnabled) {
          window.location.href = `${API_URL}${API_BASE_PATHS.AUTH.WORKOS_REDIRECT_MICROSOFT}`;
          return;
        }

        try {
          const result = await instance.loginPopup({
            scopes: ['user.read'],
          });
          onSuccess(result);
        } catch (err) {
          Logger.captureError(err as Error);
          onError();
        }
      }}
    >
      {/* SVG is from Microsoft's branding guidelines, https://learn.microsoft.com/en-us/entra/identity-platform/howto-add-branding-in-apps */}
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
        >
          <title>MS-SymbolLockup</title>
          <rect x="1" y="1" width="9" height="9" fill="#f25022" />
          <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
          <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
          <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
        </svg>
        <span>Sign in with Microsoft</span>
      </Stack>
    </Button>
  );
};

export default MicrosoftLoginButton;
